import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import PurchaseOrderDetails from "../../components/purchaseOrder/PurchaseOrderDetails.js";
import PurchaseOrderMaterialDetails from "../../components/purchaseOrder/PurchaseOrderMaterialDetails.js";
import { CommonSuccessMessages, CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import InventoryServices from "../../services/axioServices/apiServices/InventoryServices.js";
import moment from "moment";
import * as XLSX from "xlsx";
import ActionDropdown from "../../components/dropdown/ActionDropdown.js";

class PurchaseOrder extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.inventoryServices = new InventoryServices();
    this.state = {
      isGridView: true,
      isMaterialDetailsHide: true,
      isLoading: false,
      isMaterialDetailsEditing: false,
      tableStatus: "",
      isAllFieldDisable: false,
      filterDetails: {
        partyName: "",
        filterBy: "",
        materialType: "",
        status: "",
      },
      purchaseOrderDetails: {
        purchaseOrderId: "",
        partyId: "",
        email: "",
        deliveryBefore: "",
        refNo: "",
        refDate: "",
        gstApplicable: "",
        paymentTerm: "",
        freight: "",
        transportBy: "",
        bookingArea: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        zipCode: "",
        materialType: "",
      },
      pricing: {
        subTotalAmount: 0,
        totalAmount: 0,
        gstRate: 0,
        gstAmount: 0,
      },
      purchaseOrderMaterialDetials: {
        purchaseOrderMaterialDetialId: "",
        rawMaterialId: "",
        packageMaterialId: "",
        uom: "",
        qty: 0,
        rate: 0,
        per: 1,
        amount: 0,
        make: "",
        remarks: "",
      },
      partyDropdownList: [],
      rawMaterialList: [],
      packingMaterialDropDownList: [],
      purchaseOrderList: [],
      purchaseOrderMaterialList: [],
      filterByList: [
        { filterBy: "P.O No", value: "purchaseOrderNo" },
        { filterBy: "P.O Date", value: "purchaseOrderDate" },
        { filterBy: "Party name", value: "partyName" },
      ],
      typeList: [{ grnType: "Raw" }, { grnType: "Packing" }],
      statusList: [
        { status: "Order Created" },
        { status: "Email Sent" },
        { status: "Order Approved" },
      ],
      gstApplicableList: [
        { gst: "AS APPLICABLE" },
        { gst: "GST 5%" },
        { gst: "GST 12%" },
        { gst: "GST 18%" },
        { gst: "GST 28%" },
      ],
      payMentTermList: [
        { paymentTerm: "IMMIDEATE" },
        { paymentTerm: "30 DAYS" },
        { paymentTerm: "60 DAYS" },
        { paymentTerm: "90 DAYS" },
      ],
      freightList: [{ freight: "PAID" }, { freight: "UNPAID" }],
      transportList: [{ transport: "Self" }, { transport: "Courier" }],
      bookingAreaList: [{ bookingArea: "RAKANPUR" }],
      validationRules: {
        partyId: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "party name"
            ),
          },
        ],
        email: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "email"
            ),
          },
        ],
        deliveryBefore: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "delivery before date"
            ),
          },
        ],
        refNo: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "ref no"
            ),
          },
        ],
        refDate: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "ref date"
            ),
          },
        ],
        paymentTerm: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "payment term"
            ),
          },
        ],
        gstApplicable: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "gst"
            ),
          },
        ],
        freight: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "freight"
            ),
          },
        ],
        transportBy: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "transport by"
            ),
          },
        ],
        bookingArea: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "booking area"
            ),
          },
        ],
        addressLine1: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "address line 1"
            ),
          },
        ],
        addressLine2: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "address line 2"
            ),
          },
        ],
        city: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "city"
            ),
          },
        ],
        state: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "state"
            ),
          },
        ],
        zipCode: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "zip code"
            ),
          },
        ],
        materialType: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "material type"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
      validationRulesForMaterials: {
        qty: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "qty"
            ),
          },
        ],
        rate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "rate"
            ),
          },
        ],
      },
      rawMaterialIdRule: [
        {
          type: "require",
          message: CommonValidationMessages.SelectRequired.replace(
            "{0}",
            "raw material"
          ),
        },
      ],
      packageMaterialIdRule: [
        {
          type: "require",
          message: CommonValidationMessages.SelectRequired.replace(
            "{0}",
            "package material"
          ),
        },
      ],
      validStateForMaterials: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllPurchaseOrders();
  }

  getAllPurchaseOrders = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.filterDetails;
    this.inventoryServices.getAllPurchaseOrders(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        let res = response.responseData;
        this.setState({ purchaseOrderList: res }, () => {
          this.getAllPartyDropdown();
        });
      } else {
        this.setState({ tableStatus: "" })
        this.getAllPartyDropdown();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getAllPartyDropdown = () => {
    this.commonServices.getAllPartyDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.partyName,
          value: item._id,
          email: item.email,
        }));
        this.setState({ partyDropdownList: dropdownItems }, () => {
          this.getCompanyDetails();
        });
      } else {
        this.getCompanyDetails();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getCompanyDetails = () => {
    this.commonServices.getCompanyDetails().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let companyAddress = response.responseData[0];
        let purchaseOrder = this.state.purchaseOrderDetails;
        purchaseOrder.addressLine1 = companyAddress.addressLine1;
        purchaseOrder.addressLine2 = companyAddress.addressLine2;
        purchaseOrder.city = companyAddress.city;
        purchaseOrder.state = companyAddress.state;
        purchaseOrder.zipCode = companyAddress.pinCode;
        this.setState({ purchaseOrder: companyAddress }, () => {
          this.getAllRMDropdown();
        });
      } else {
        this.getAllRMDropdown();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getAllRMDropdown = () => {
    this.commonServices.getAllRMDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.rmName,
          value: item._id,
          uom: item.rmUOM,
        }));
        this.setState({ rawMaterialList: dropdownItems }, () => {
          this.getAllPackingMaterialDropdown();
        });
      } else {
        this.getAllPackingMaterialDropdown();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getAllPackingMaterialDropdown = () => {
    this.commonServices.getAllPackingMaterialDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.pmName,
          value: item._id,
          uom: item.pmUOM,
        }));
        this.setState({ packingMaterialDropDownList: dropdownItems });
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.resetForm()
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true, isEditing: false });
  };

  openPurchaseOrderMaterialOrderSection = () => {
    this.setState({ isMaterialDetailsHide: false });
  };

  setFilterParameters = (selected, drpIdentity, section) => {
    let details = this.state.purchaseOrderDetails;
    let detail1 = this.state.purchaseOrderMaterialDetials;
    if (section === "MaterialDetails") {
      detail1[drpIdentity] = selected.value;
      detail1.uom = selected.uom;
      this.setState({ purchaseOrderMaterialDetials: detail1 });
    } else {
      details[drpIdentity] = selected.value;
      details.email = selected.email;
      this.setState({ purchaseOrderDetails: details });
    }
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    let details = this.state.purchaseOrderDetails;
    let details1 = this.state.purchaseOrderMaterialDetials;
    let details2 = this.state.filterDetails;
    if (section === "MaterialDetails") {
      details1[name] = value.toUpperCase();
      this.setState({ purchaseOrderMaterialDetials: details1 });
    } else if (section === "FilterDetails") {
      details2[name] = value.toUpperCase();
      this.setState({ filterDetails: details2 }, () => {
        this.getAllPurchaseOrders();
      });
    } else {
      details[name] = value.toUpperCase();
      this.setState({ purchaseOrderDetails: details });
    }
  };

  handleDropdownChange = (e, name, section) => {
    const value = e.target.value;
    if (section === "FilterDetails") {
      let detail = this.state.filterDetails;
      detail[name] = value;
      this.setState({ filterDetails: detail }, () => {
        this.getAllPurchaseOrders();
      });
    } else {
      let details = this.state.purchaseOrderDetails;
      details[name] = value;
      this.setState({ purchaseOrderDetails: details });
    }
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.purchaseOrderDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  addEditPurchaseOrderDetails = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      let request = this.state.purchaseOrderDetails;
      if (request.purchaseOrderId === "" || request.purchaseOrderId === null) {
        delete request.purchaseOrderId;
        request.status = "Order Created";
      }
      this.inventoryServices
        .addEditPurchaseOrderDetails(request)
        .then((response) => {
          if (response.statusCode === 200 && response.responseData !== null) {
            let purchaseOrderDetails = this.state.purchaseOrderDetails;
            purchaseOrderDetails.purchaseOrderId = response.responseData._id;
            this.setState(
              { purchaseOrderDetails: purchaseOrderDetails },
              () => {
                this.getPurchaseOrderMaterialDetailsByPurchaseOrderId(
                  this.state.purchaseOrderDetails.purchaseOrderId
                );
              }
            );
          } else {
            this.SwalServices.Error(
              response.Message
            );
          }
        });
    }
  };

  handleChangeForNumber = (event, name) => {
    let value = event.target.value;

    if (this.state.purchaseOrderMaterialDetials[name] === 0 && value !== "0") {
      value = value.replace(/^0+/, "");
    }

    let detail = this.state.purchaseOrderMaterialDetials;
    if (name === "per") {
      if (value === "0") {
        detail[name] = "1";
      } else {
        detail[name] = value;
      }
    } else {
      detail[name] = value;
    }
    detail.amount =
      (detail.qty * detail.rate) / (detail.per > 0 ? detail.per : 1);
    detail.amount = detail.amount.toFixed(2);
    this.setState({ purchaseOrderMaterialDetials: { ...detail } });
  };

  getPurchaseOrderDetailsById = (OrderDetails) => {
    const detail = this.state.purchaseOrderDetails;
    detail.partyId = OrderDetails.partyId._id;
    detail.refDate = moment(OrderDetails.refDate).format("yyyy-MM-DD");
    detail.purchaseOrderId = OrderDetails._id;
    detail.email = OrderDetails.email;
    detail.refNo = OrderDetails.refNo;
    detail.gstApplicable = OrderDetails.gstApplicable;
    detail.paymentTerm = OrderDetails.paymentTerm;
    detail.freight = OrderDetails.freight;
    detail.transportBy = OrderDetails.transportBy;
    detail.bookingArea = OrderDetails.bookingArea;
    detail.addressLine1 = OrderDetails.addressLine1;
    detail.addressLine2 = OrderDetails.addressLine2;
    detail.city = OrderDetails.city;
    detail.state = OrderDetails.state;
    detail.zipCode = OrderDetails.zipCode;
    detail.materialType = OrderDetails.materialType;
    detail.status = OrderDetails.status;
    detail.deliveryBefore = moment(OrderDetails.deliveryBefore).format(
      "yyyy-MM-DD"
    );
    if (detail.status === 'Order Approved') {
      this.setState({ isAllFieldDisable: true })
    } else {
      this.setState({ isAllFieldDisable: false })
    }
    this.setState({ purchaseOrderDetails: detail }, () => {
      this.setState({ isGridView: false });
    });
  };

  getPurchaseOrderMaterialDetailsByPurchaseOrderId = (id, isForPrintData) => {
    this.inventoryServices
      .getPurchaseOrderMaterialDetailsByPurchaseOrderId(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let details = response.responseData;

          let subTotalAmount = response.responseData.reduce(
            (sum, item) => sum + item.amount,
            0
          );
          let purchaseDetails = this.state.purchaseOrderDetails;
          let gstRate = 0;
          if (purchaseDetails.gstApplicable === "GST 5%") {
            gstRate = 5;
          } else if (purchaseDetails.gstApplicable === "GST 12%") {
            gstRate = 12;
          } else if (purchaseDetails.gstApplicable === "GST 18%") {
            gstRate = 18;
          } else if (purchaseDetails.gstApplicable === "GST 28%") {
            gstRate = 28;
          }
          let gstAmount = subTotalAmount * (gstRate / 100);
          let totalAmount = subTotalAmount + gstAmount;

          let pricing = this.state.pricing;
          pricing.subTotalAmount = subTotalAmount;
          pricing.gstAmount = gstAmount;
          pricing.gstRate = gstRate;
          pricing.totalAmount = totalAmount;

          this.setState(
            { purchaseOrderMaterialList: details, pricing: pricing },
            () => {
              if (isForPrintData === true) {
                this.printPurchaseOrderDetails();
              } else {
                this.setState({
                  isMaterialDetailsHide: false,
                  isMaterialDetailsEditing: false,
                });
              }
            }
          );
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  deletePurchaseOrderDetailsById = (id) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete this purchase order ?`
    ).then((response) => {
      if (response === true) {
        this.inventoryServices.deletePurchaseOrderDetailsById(id).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.getAllPurchaseOrders();
            this.SwalServices.Success(response.Message);
          } else {
            this.SwalServices.Error(response.Message);
          }
        });

      }
    })

  };

  sendPurchaseOrderMail = (orderDetails) => {
    let request = {
      purchaseOrderId: orderDetails._id,
      partyId: orderDetails.partyId,
      email: orderDetails.email,
      gstApplicable: orderDetails.gstApplicable,
    };
    this.inventoryServices.sendPurchaseOrderMail(request).then((response) => {
      if (response.statusCode === 200 && response.responseData !== null) {
        this.SwalServices.Success(response.Message);
        this.getAllPurchaseOrders();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  printPurchaseOrderDetails = () => {
    const { purchaseOrderMaterialList } = this.state;

    if (purchaseOrderMaterialList && purchaseOrderMaterialList.length > 0) {
      const transformedData = purchaseOrderMaterialList.map((item, index) => ({
        SN: index + 1,
        "Item Name": item.packageMaterialId
          ? item.packageMaterialId.pmName
          : item.rawMaterialId.rmName,
        Unit: item.packageMaterialId
          ? item.packageMaterialId.pmUOM
          : item.rawMaterialId.rmUOM,
        Quantity: item.qty.toFixed(2),
        Rate: item.rate.toFixed(2),
        Per: item.per,
        Amount: item.amount.toFixed(2),
      }));

      const totalAmount = transformedData.reduce(
        (sum, item) => sum + parseFloat(item.Amount),
        0
      );

      transformedData.push({
        SN: "",
        "Item Name": "",
        Unit: "",
        Quantity: "",
        Rate: "",
        Per: "Total:- ",
        Amount: totalAmount.toFixed(2),
      });

      const worksheet = XLSX.utils.json_to_sheet(transformedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Purchase Order List");
      XLSX.writeFile(
        workbook,
        `PurchaseOrder${moment(new Date()).format("yyyy-MM-DD")}.xlsx`
      );
    }
  };

  approvePurchaseOrderByPurchaseId = (id) => {
    this.inventoryServices
      .approvePurchaseOrderByPurchaseId(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData !== null) {
          this.getAllPurchaseOrders();
          this.SwalServices.Success(response.Message);
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  addEditPurchaserOrderMaterialDetails = () => {
    let isValidAllFieldsForMaterialDetails =
      this.isValidAllFieldsForMaterialDetails();
    if (isValidAllFieldsForMaterialDetails) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.purchaseOrderMaterialDetials;
        request.purchaseOrderId = this.state.purchaseOrderDetails.purchaseOrderId;

        if (
          request.purchaseOrderMaterialDetialId === "" ||
          request.purchaseOrderMaterialDetialId === null
        ) {
          delete request.purchaseOrderMaterialDetialId;
        }

        if (this.state.purchaseOrderDetails.materialType === "Raw") {
          delete request.packageMaterialId;
        } else {
          delete request.rawMaterialId;
        }

        if (request.qty === "" || request.qty === null) {
          request.qty = 0;
        }
        if (request.rate === "" || request.rate === null) {
          request.rate = 0;
        }
        if (request.per === "" || request.per === null) {
          request.per = 1;
        }
        this.inventoryServices
          .addEditPurchaserOrderMaterialDetails(request)
          .then((response) => {
            if (response.statusCode === 200 && response.responseData !== null) {
              this.SwalServices.Success(response.Message);
              this.resetMaterialDetails();
              this.setState({ isLoading: false })
              this.getPurchaseOrderMaterialDetailsByPurchaseOrderId(
                this.state.purchaseOrderDetails.purchaseOrderId
              );
            } else {
              this.SwalServices.Error(
                response.Message
              );
              this.setState({ isLoading: false })
            }
          });
      })
    }
  };

  isValidAllFieldsForMaterialDetails = () => {
    const validationRule = this.state.validationRulesForMaterials;
    if (this.state.purchaseOrderDetails.materialType === "Raw") {
      validationRule.rawMaterialId = this.state.rawMaterialIdRule;
    } else {
      validationRule.packageMaterialId = this.state.packageMaterialIdRule;
    }
    const newValidState = isValidForm(
      this.state.purchaseOrderMaterialDetials,
      validationRule,
      this.state.validStateForMaterials
    );
    this.setState({ validStateForMaterials: newValidState });
    return newValidState.isValid;
  };

  resetMaterialDetails = () => {
    let validStateForMaterials = this.state.validStateForMaterials;
    validStateForMaterials.isValid = true;
    validStateForMaterials.error = {};
    let details = this.state.purchaseOrderMaterialDetials;
    details.purchaseOrderMaterialDetialId = "";
    details.packageMaterialId = "";
    details.rawMaterialId = "";
    details.amount = 0;
    details.rate = 0;
    details.qty = 0;
    details.per = 1;
    details.uom = "";
    details.make = "";
    details.remarks = "";
    this.setState({ purchaseOrderMaterialDetials: details, validStateForMaterials: validStateForMaterials });
  };

  resetPurchaseOrderDetails = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.purchaseOrderDetails;
    details.purchaseOrderId = "";
    details.partyId = "";
    details.email = "";
    details.deliveryBefore = "";
    details.refNo = "";
    details.refDate = "";
    details.gstApplicable = "";
    details.paymentTerm = "";
    details.freight = "";
    details.transportBy = "";
    details.bookingArea = "";
    // details.addressLine1 = "";
    // details.addressLine2 = "";
    // details.city = "";
    // details.state = "";
    // details.zipCode = "";
    details.materialType = "";
    this.setState({ purchaseOrderDetails: details, validState: validState });
  };

  resetFilterDetails = () => {
    let filterDetails = this.state.filterDetails;
    filterDetails.partyName = "";
    filterDetails.filterBy = "";
    filterDetails.materialType = "";
    filterDetails.status = "";
    this.setState(() => {
      this.getAllPurchaseOrders();
    })
  }

  resetForm = () => {
    this.resetFilterDetails();
    this.resetPurchaseOrderDetails();
    this.resetMaterialDetails();
    this.setState({ isMaterialDetailsHide: true, tableStatus: "" }
    );
  }

  getpurchaseOrderMaterialDetialsById = (materialDetails) => {
    let details = this.state.purchaseOrderMaterialDetials;
    details.packageMaterialId = materialDetails.packageMaterialId
      ? materialDetails.packageMaterialId
      : "";
    details.rawMaterialId = materialDetails.rawMaterialId
      ? materialDetails.rawMaterialId._id
      : "";
    details.uom = materialDetails.uom;
    details.qty = materialDetails.qty;
    details.rate = materialDetails.rate;
    details.per = materialDetails.per;
    details.amount = Number(materialDetails.amount).toFixed(2);
    details.make = materialDetails.make;
    details.remarks = materialDetails.remarks;
    this.setState({
      purchaseOrderMaterialDetials: details,
      isMaterialDetailsEditing: true,
    });
  };

  deletepurchaseOrderMaterialDetialsById = (id) => {
    this.inventoryServices.deletepurchaseOrderMaterialDetialsById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.getPurchaseOrderMaterialDetailsByPurchaseOrderId(
          this.state.purchaseOrderDetails.purchaseOrderId
        );
        this.SwalServices.Success(response.Message);
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  closeMaterialDetails = () => {
    this.resetMaterialDetails();
    this.setState({ isMaterialDetailsHide: true });
  };

  onClickHandlers = (buttonType, item) => {
    if (buttonType === "edit") {
      this.getPurchaseOrderDetailsById(item);
    }
    if (buttonType === "delete") {
      this.deletePurchaseOrderDetailsById(item._id);
    }
    if (buttonType === "sendEmail") {
      this.sendPurchaseOrderMail(item);
    }
    if (buttonType === "print") {
      this.printPurchaseOrderDetails(item);
    }
    if (buttonType === "approveOrder") {
      this.approvePurchaseOrderByPurchaseId(item._id);
    }
  };

  render() {
    const options = ["edit", "delete", "sendEmail", "print", "approveOrder"];
    return (
      <div className="purchaseorder-page">
        {this.state.isGridView === true ? (
          <>
            <div className="item-search mb-3.5">
              <div className="item-grp !gap-2.5 flex mb-3.5">
                <div className="item-search-box">
                  <label>Party Name</label>
                  <input
                    className="inputFocus"
                    type="text"
                    id="partyName"
                    name="partyName"
                    autoComplete="off"
                    value={this.state.filterDetails.partyName}
                    onChange={(event) =>
                      this.handleChange(event, "partyName", "FilterDetails")
                    }
                  />
                </div>
                <div className="dropdown-grp">
                  <label>Filter By</label>
                  <select
                    value={this.state.filterDetails.filterBy}
                    onChange={(e) =>
                      this.handleDropdownChange(e, "filterBy", "FilterDetails")
                    }
                  >
                    <option>Select</option>
                    {this.state.filterByList.map((x, key) => (
                      <option key={key} value={x.value}>
                        {x.filterBy}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="dropdown-grp">
                  <label>Status</label>
                  <select
                    name="status"
                    value={this.state.filterDetails.status}
                    onChange={(e) =>
                      this.handleDropdownChange(e, "status", "FilterDetails")
                    }
                  >
                    <option>Select</option>
                    {this.state.statusList.map((x, key) => (
                      <option key={key} value={x.status}>
                        {x.status}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="dropdown-grp">
                  <label>Material Type</label>
                  <select
                    name="materialType"
                    value={this.state.filterDetails.materialType}
                    onChange={(e) =>
                      this.handleDropdownChange(
                        e,
                        "materialType",
                        "FilterDetails"
                      )
                    }
                  >
                    <option>Select</option>
                    {this.state.typeList.map((x, key) => (
                      <option key={key} value={x.grnType}>
                        {x.grnType}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <button className="add-btn" onClick={() => this.closeGridView()}>
                Add new Item
              </button>
            </div>
            <div className="itemList-table" >
              <div className="table-container" style={{ overflowY: "auto", height: "calc(100vh - 180px)" }} >
                <table className="itemList">
                  <thead style={{ zIndex: "10" }}>
                    <tr>
                      <td style={{ width: "10%" }}>Order No</td>
                      <td style={{ width: "10%" }}>Order Date</td>
                      <td style={{ width: "30%" }}>Party Name</td>
                      <td style={{ width: "15%" }}>Status</td>
                      <td style={{ width: "10%" }}>Material Type</td>
                      <td style={{ width: "15%", textAlign: "center" }}>Action</td>
                    </tr>
                  </thead>
                  {this.state.purchaseOrderList &&
                    this.state.purchaseOrderList.length > 0 ? (
                    this.state.purchaseOrderList.map((item, key) => (
                      <tbody key={key} style={{ zIndex: "1" }}>
                        <tr>
                          <td>{item.purchaseOrderNo}</td>
                          <td>
                            {moment(item.purchaseOrderDate).format(
                              "DD MMM yyyy"
                            )}
                          </td>
                          <td>{item.partyId.partyName}</td>
                          <td>{item.status}</td>
                          <td>{item.materialType}</td>
                          <td style={{ textAlign: "center" }}>
                            <ActionDropdown
                              options={options}
                              item={item}
                              onClickHandle={this.onClickHandlers.bind(this)}
                              isDeleteButtonDisable={item.status === 'Order Approved' ? true : false}
                              isEmailButtonDisable={item.status === 'Order Approved' ? true : false}
                              isApproveButtonDisable={item.status === 'Order Approved' ? true : false}
                            />
                          </td>
                        </tr>
                      </tbody>
                    ))
                  ) : this.state.purchaseOrderList &&
                    this.state.purchaseOrderList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={6} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.purchaseOrderList &&
                    this.state.purchaseOrderList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
                </table>
              </div>
            </div>
          </>
        ) : null}
        {this.state.isGridView === false ? (
          <div className="item-listing">
            {this.state.isMaterialDetailsHide ? (
              <PurchaseOrderDetails
                openPurchaseOrderMaterialOrderSection={this.openPurchaseOrderMaterialOrderSection.bind(
                  this
                )}
                purchaseOrderDetails={this.state.purchaseOrderDetails}
                partyDropdownList={this.state.partyDropdownList}
                gstApplicableList={this.state.gstApplicableList}
                payMentTermList={this.state.payMentTermList}
                freightList={this.state.freightList}
                transportList={this.state.transportList}
                bookingAreaList={this.state.bookingAreaList}
                setFilterParameters={this.setFilterParameters.bind(this)}
                handleChange={this.handleChange.bind(this)}
                handleDropdownChange={this.handleDropdownChange.bind(this)}
                addEditPurchaseOrderDetails={this.addEditPurchaseOrderDetails.bind(
                  this
                )}
                validState={this.state.validState}
                typeList={this.state.typeList}
                resetPurchaseOrderDetails={this.resetPurchaseOrderDetails.bind(
                  this
                )}
                openGridView={this.openGridView.bind(this)}
                isAllFieldDisable={this.state.isAllFieldDisable}
              />
            ) : (
              <PurchaseOrderMaterialDetails
                isLoading={this.state.isLoading}
                isMaterialDetailsEditing={this.state.isMaterialDetailsEditing}
                purchaseOrderMaterialDetials={
                  this.state.purchaseOrderMaterialDetials
                }
                rawMaterialList={this.state.rawMaterialList}
                packingMaterialDropDownList={
                  this.state.packingMaterialDropDownList
                }
                purchaseOrderDetails={this.state.purchaseOrderDetails}
                handleChangeForNumber={this.handleChangeForNumber.bind(this)}
                handleChange={this.handleChange.bind(this)}
                setFilterParameters={this.setFilterParameters.bind(this)}
                validStateForMaterials={this.state.validStateForMaterials}
                addEditPurchaserOrderMaterialDetails={this.addEditPurchaserOrderMaterialDetails.bind(
                  this
                )}
                purchaseOrderMaterialList={
                  this.state.purchaseOrderMaterialList
                }
                getpurchaseOrderMaterialDetialsById={this.getpurchaseOrderMaterialDetialsById.bind(
                  this
                )}
                deletepurchaseOrderMaterialDetialsById={this.deletepurchaseOrderMaterialDetialsById.bind(
                  this
                )}
                closeMaterialDetails={this.closeMaterialDetails.bind(this)}
                resetMaterialDetails={this.resetMaterialDetails.bind(this)}
                pricing={this.state.pricing}
                openGridView={
                  this.openGridView.bind(this)
                }
                isAllFieldDisable={this.state.isAllFieldDisable}
              />
            )}
          </div>
        ) : null}
      </div>
    );
  }
}
export default PurchaseOrder;
